"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = IntersectionDesignerComponent;
const react_1 = __importDefault(require("react"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const update_1 = __importDefault(require("@mwater/react-library/lib/update"));
const rc_slider_1 = __importDefault(require("rc-slider"));
const AxisComponent_1 = __importDefault(require("../../../axes/AxisComponent"));
const ColorComponent_1 = __importDefault(require("../../../ColorComponent"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_ui_2 = require("@mwater/expressions-ui");
const ListEditorComponent_1 = require("@mwater/react-library/lib/ListEditorComponent");
const PivotChartUtils_1 = require("./PivotChartUtils");
const AxisBuilder_1 = __importDefault(require("../../../axes/AxisBuilder"));
const immer_1 = __importDefault(require("immer"));
// Design an intersection of a pivot table
function IntersectionDesignerComponent(props) {
    // Determine table to use (use overrideTable if set, otherwise use table from props)
    const table = props.intersection.tableOverride || props.table;
    const handleBackgroundColorAxisChange = (backgroundColorAxis) => {
        const opacity = props.intersection.backgroundColorOpacity || 1;
        props.onChange({ ...props.intersection, backgroundColorAxis, backgroundColorOpacity: opacity });
    };
    const handleBackgroundColorChange = (backgroundColor) => {
        const opacity = props.intersection.backgroundColorOpacity || 1;
        props.onChange({ ...props.intersection, backgroundColor, backgroundColorOpacity: opacity });
    };
    const handleBackgroundColorConditionsChange = (backgroundColorConditions) => {
        const opacity = props.intersection.backgroundColorOpacity || 1;
        props.onChange({ ...props.intersection, backgroundColorConditions, backgroundColorOpacity: opacity });
    };
    const handleBackgroundColorOpacityChange = (newValue) => {
        props.onChange({ ...props.intersection, backgroundColorOpacity: newValue / 100 });
    };
    const handleFilterChange = (filter) => {
        props.onChange({ ...props.intersection, filter });
    };
    const handleTableOverrideChange = (tableOverride) => {
        props.onChange({ ...props.intersection, tableOverride });
    };
    const renderValueAxis = () => {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Calculation`, help: T `This is the calculated value that is displayed. Leave as blank to make an empty section` },
            react_1.default.createElement(AxisComponent_1.default, { schema: props.schema, dataSource: props.dataSource, table: table, types: ["enum", "text", "boolean", "date", "number"], aggrNeed: "required", value: props.intersection.valueAxis, onChange: valueAxis => props.onChange({ ...props.intersection, valueAxis }), showFormat: true, filters: props.filters })));
    };
    const renderNullValue = () => {
        if (props.intersection.valueAxis) {
            return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Show Empty Cells as` },
                react_1.default.createElement(ui.TextInput, { value: props.intersection.valueAxis.nullLabel ?? null, emptyNull: true, onChange: nullLabel => props.onChange({ ...props.intersection, valueAxis: { ...props.intersection.valueAxis, nullLabel: nullLabel ?? undefined } }), placeholder: T `Blank` })));
        }
        return null;
    };
    const renderFilter = () => {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui.Icon, { id: "glyphicon-filter" }),
                " ",
                T `Filters`) },
            react_1.default.createElement(expressions_ui_1.FilterExprComponent, { schema: props.schema, dataSource: props.dataSource, onChange: handleFilterChange, table: table, value: props.intersection.filter })));
    };
    const renderStyling = () => {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, key: "styling", label: T `Styling` },
            react_1.default.createElement(ui.Checkbox, { key: "bold", inline: true, value: props.intersection.bold, onChange: bold => props.onChange({ ...props.intersection, bold }) }, T `Bold`),
            react_1.default.createElement(ui.Checkbox, { key: "italic", inline: true, value: props.intersection.italic, onChange: italic => props.onChange({ ...props.intersection, italic }) }, T `Italic`)));
    };
    const renderBackgroundColorConditions = () => {
        return (react_1.default.createElement(BackgroundColorConditionsComponent, { schema: props.schema, dataSource: props.dataSource, table: table, colorConditions: props.intersection.backgroundColorConditions, onChange: handleBackgroundColorConditionsChange }));
    };
    const renderBackgroundColorAxis = () => {
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Background Color From Values`, help: T `This is an optional background color to set on cells that is controlled by the data` },
            react_1.default.createElement(AxisComponent_1.default, { schema: props.schema, dataSource: props.dataSource, table: table, types: ["enum", "text", "boolean", "date"], aggrNeed: "required", value: props.intersection.backgroundColorAxis, onChange: handleBackgroundColorAxisChange, showColorMap: true, filters: props.filters })));
    };
    const renderBackgroundColor = () => {
        if (props.intersection.backgroundColorAxis) {
            return;
        }
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Background Color`, help: T `This is an optional background color to set on all cells` },
            react_1.default.createElement(ColorComponent_1.default, { color: props.intersection.backgroundColor, onChange: handleBackgroundColorChange })));
    };
    const renderBackgroundColorOpacityControl = () => {
        if (!props.intersection.backgroundColorAxis &&
            !props.intersection.backgroundColor &&
            !props.intersection.backgroundColorConditions?.[0]) {
            return;
        }
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Background Opacity: ${Math.round((props.intersection.backgroundColorOpacity ?? 1) * 100)}%` },
            react_1.default.createElement(rc_slider_1.default, { min: 0, max: 100, step: 1, tipTransitionName: "rc-slider-tooltip-zoom-down", value: (props.intersection.backgroundColorOpacity ?? 1) * 100, onChange: handleBackgroundColorOpacityChange })));
    };
    const renderSegmentValueAxisOverride = (segment) => {
        // Get type of segment axis
        const axisBuilder = new AxisBuilder_1.default({ schema: props.schema });
        const segmentValueAxisType = axisBuilder.getAxisType(segment.valueAxis);
        if (!segmentValueAxisType) {
            return null;
        }
        const overrideValueAxis = (props.intersection.segmentValueAxisOverrides || {})[segment.id];
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: (segment.label || axisBuilder.summarizeAxis(segment.valueAxis)) + ":" },
            react_1.default.createElement(AxisComponent_1.default, { schema: props.schema, dataSource: props.dataSource, table: table, types: [segmentValueAxisType], aggrNeed: "none", value: overrideValueAxis, onChange: valueAxis => props.onChange((0, immer_1.default)(props.intersection, (draft) => {
                    draft.segmentValueAxisOverrides = draft.segmentValueAxisOverrides || {};
                    draft.segmentValueAxisOverrides[segment.id] = valueAxis;
                })), allowExcludedValues: false, collapseCategories: true })));
    };
    const renderSegmentValueAxisOverrides = () => {
        if (!props.intersection.tableOverride) {
            return null;
        }
        // Get all segments
        const segments = (0, PivotChartUtils_1.getAllSegments)(props.design.rows).concat((0, PivotChartUtils_1.getAllSegments)(props.design.columns));
        // Filter out segments that are not intersecting
        const intersectingSegmentIds = props.intersectionId.split(/[,:]/).filter(id => id !== "");
        const intersectingSegments = segments.filter(segment => intersectingSegmentIds.includes(segment.id) && segment.valueAxis);
        return (react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Fields to disaggregate data by (required)` }, intersectingSegments.map(segment => renderSegmentValueAxisOverride(segment))));
    };
    const renderOverrideTable = () => {
        return (react_1.default.createElement(ui.CollapsibleSection, { label: T `Advanced: Override Data Source`, hint: T `Use a different data source for this cell`, labelMuted: true, initiallyOpen: props.intersection.tableOverride != null },
            react_1.default.createElement(expressions_ui_1.TableSelectComponent, { schema: props.schema, value: props.intersection.tableOverride, onChange: handleTableOverrideChange }),
            react_1.default.createElement("br", null),
            renderSegmentValueAxisOverrides()));
    };
    return (react_1.default.createElement("div", null,
        renderValueAxis(),
        renderNullValue(),
        renderFilter(),
        renderStyling(),
        renderBackgroundColorAxis(),
        renderBackgroundColorConditions(),
        renderBackgroundColor(),
        renderBackgroundColorOpacityControl(),
        renderOverrideTable()));
}
/** Displays background color conditions */
class BackgroundColorConditionsComponent extends react_1.default.Component {
    handleAdd = () => {
        const colorConditions = (this.props.colorConditions || []).slice();
        colorConditions.push({});
        this.props.onChange(colorConditions);
    };
    render() {
        // List conditions
        return (react_1.default.createElement(ui.FormGroup, { label: T `Color Conditions`, labelMuted: true, help: T `Add conditions that, if met, set the color of the cell. Useful for flagging certain values` },
            react_1.default.createElement(ListEditorComponent_1.ListEditorComponent, { items: this.props.colorConditions || [], renderItem: (item, index, onItemChange) => {
                    return (react_1.default.createElement(BackgroundColorConditionComponent, { key: index, colorCondition: item, table: this.props.table, schema: this.props.schema, dataSource: this.props.dataSource, onChange: onItemChange }));
                }, onItemsChange: this.props.onChange }),
            react_1.default.createElement(ui.Button, { type: "link", size: "sm", onClick: this.handleAdd },
                react_1.default.createElement(ui.Icon, { id: "fa-plus" }),
                T `Add Condition`)));
    }
}
/**
 * Displays single background color condition
 */
class BackgroundColorConditionComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
    }
    // Updates intersection with the specified changes
    update(...args) {
        return (0, update_1.default)(this.props.colorCondition, this.props.onChange, arguments);
    }
    render() {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Condition` },
                react_1.default.createElement(expressions_ui_2.ExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, onChange: this.update("condition"), types: ["boolean"], aggrStatuses: ["aggregate", "literal"], table: this.props.table, value: this.props.colorCondition.condition })),
            react_1.default.createElement(ui.FormGroup, { labelMuted: true, label: T `Color`, hint: T `Color to display when condition is met` },
                react_1.default.createElement(ColorComponent_1.default, { color: this.props.colorCondition.color, onChange: this.update("color") }))));
    }
}
